import { createContext, useContext } from 'react';

interface AppPanelContainerContextValue {
  onResizeMouseDown: (e: React.MouseEvent) => void;
  onResizeDoubleClick: () => void;
  isResizing: boolean;
  isResizable: boolean;
  isVisible: boolean;
  isCollapsed: boolean;
}

const AppPanelContainerContext = createContext<
  AppPanelContainerContextValue | undefined
>(undefined);

export const AppPanelContainerProvider = AppPanelContainerContext.Provider;

export const useAppPanelContainerContext = () => {
  const context = useContext(AppPanelContainerContext);
  if (context === undefined) {
    throw new Error(
      'useAppPanelContainerContext must be used within an AppPanelContainerProvider',
    );
  }
  return context;
};
